/** @jsxImportSource @emotion/react */
import { Button, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, Divider, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, List, ListItem, Snackbar, ToggleButton, ToggleButtonGroup, Typography, colors, useMediaQuery, useTheme, Box, CircularProgress } from '@mui/material';

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import { useFormik } from 'formik';
import { useState, useEffect, useRef, useContext } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import * as yup from 'yup';
import { StyledTextField } from '../../Components/CustomTextfield';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useDispatch, useSelector } from 'react-redux';
import { addStageData, updateStepper } from '../../Helper/Redux/reducers/upDown';
import { useLocation, useNavigate } from 'react-router-dom';
import { detailChecker, steps, getGlobalSteper, Steps } from '../../Helper/AppStepperData';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import getCookie from '../../Helper/Cookies/cookies';
import FullScreenLoader from '../../Components/FullScreenLoader';
import { getObjections, objectionNavigation, setObjections } from '../../Helper/Functions';
import UploadPAN from './UploadPAN';
import PDFViewer from "../../Components/PDFViewer";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { onFileSelection } from '../../Components/Upload/helper';
import Upload from '../../Components/Upload';

let value=[]
let segFlag=true
let segValues=[]
let isErrorSubmit
let isUploadedSubmit

function PANVerification(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const isMidScreen = useMediaQuery(theme.breakpoints.down('lg'))
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const [segmentOptions, setSegmentOptions] = useState([])
    const [openKRAVerifiedPopup, setOpenKRAVerifiedPopup] = useState(false)
    const [loading, setLoading] = useState(false)
    const [objectionState, setObjectionState] = useState({ "isObjection": false, "objections": [] })
    const [disableAllFields, setDisableAllFields] = useState(false)
    const [uploadedPANImage, setUploadedPANImage] = useState()
    const [showUploadedPANDeleteIcon, setShowUploadedPANDeleteIcon] = useState(true)
    const [showUploadPAN, setShowUploadPAN] = useState(false)
    const [panDetails, setPanDetails] = useState()
    const [uploadedPANProofID, setUploadedPANProofID] = useState()
    const [showPdfPopup, setShowPdfPopup] = useState(false)
	const [showFailPopup, setShowFailPopup] = useState({
        "showPopup":false,
        "showPopupMessage":""
    })
    const localeText = useContext(Il8nContext)
    const [openAadhaarSeededPopup, setOpenAadhaarSeededPopup] = useState(false)
    const [aadhaarSeededMessage, setAadhaarSeededMessage] = useState()
    const [indexValue, setIndexValue] = useState(0)
    const [openInfoPopup, setOpenInfoPopup] = useState(false)
    const [isStatus, setIsStatus] = useState("")
    const [isUploaded, setIsUploaded] = useState('')
    const [imageData, setImageData] = useState({})
    const [ocrUploadLoading,setOcrUploadLoading] = useState(false)
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const [documentData, setDocumentData] = useState([])
    const [panDetailsStatus, setPanDetailsStatus] = useState(false)
    useEffect(() => {
        if (getCookie("referalCode")) {
            formik.setFieldValue("apCode", getCookie("referalCode"))
        }

        if (store.isPanVerifiedDataNotFound == true) {
            setResponseStatus({ "message": localeText?.kycVerificationKindlyCon, "type": "warning" })
            setSnackBarOpen(true)
            dispatch(addStageData({ ...store, isPanVerifiedDataNotFound: false }))
        }
        if (store.isDigilockerDataNotFound == true) {
            setResponseStatus({ "message": localeText?.kycVerificationKindlyContinue, "type": "error" })
            setSnackBarOpen(true)
            dispatch(addStageData({ ...store, isDigilockerDataNotFound: false }))
        }


        getSegments()
        getStageDetails()

        let objectionValue = getObjections()
        let objections = objectionValue?.filter(objection => objection.navigationPath == "/KYCVerification")

        if (objections?.length > 0) {
            objections = objections.map(objection => {
                return {
                    "objectionDescription": objection.objectionDescription,
                    "remark": objection.remark
                }
            })

            objectionValue = objectionValue.map(objection => {
                if (objection.navigationPath == "/KYCVerification") {
                    objection.isNavigationDone = true;
                }
                return objection
            })

            setObjections(objectionValue)
            setObjectionState({ isObjection: true, objections })
        }
        getIncomeProofDocumentDetails()
    }, [])

    useEffect(()=>{
        checkSegments()
    },[segValues])

    function getIncomeProofDocumentDetails(){
        setDocumentData([])
        axios.post(process.env.REACT_APP_API_URL + config.getSegment,{})
        .then(response => {
            setDocumentData(response.data.success?.documentList)
        })
        .catch(exception => {
            console.log(exception)
        })
    }

    const checkSegments = () => {
        segValues=formik.values.segments
        for (let i = 0; i < segValues.length; i++) {
            if (segValues.includes(3) || segValues.includes(4) || segValues.includes(5)) {
                segFlag = false;
                break;
            }else{
                segFlag = true;
                break;
            }
        }
        return !segFlag
    }

    const getStageDetails = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    !(stepper?.length) && dispatch(updateStepper(getGlobalSteper(resp.data.success.stageDetilasList)))
                    if (detailChecker(resp.data.success.stageDetilasList, 4)) {
                        setShowUploadedPANDeleteIcon(false)
                    }
                    if (detailChecker(resp.data.success.stageDetilasList, 7)) {
                        getPANDetails()
                    }
                    else {
                        setLoading(false)
                    }
                    if (resp?.data?.success?.stageDetilasList && resp?.data?.success?.stageDetilasList?.length > 0 ) {
                        const hasStatusOne = resp?.data?.success?.stageDetilasList?.some(stage => stage?.status === 1);
                        if (hasStatusOne) {
                            console.log("At least one stage has status 1. Executing function...");
                            localStorage.setItem("appStages", JSON.stringify(resp.data.success.stageDetilasList))
                        function modifySteps (mf) {
                            if (mf) {
                                Steps[1].steps.push({stageCode: "NOMM"})
                            }
                            return Steps
                        }

                        const getStep = (response, code) => {
                            const step = response.filter((st) => {return st.stageCode === code})
                            return step[0].status
                        }

                        modifySteps(resp.data.success.isMF).forEach((step) => {
                            step.status = getStep(resp.data.success.stageDetilasList, step.stageCode)
                            if (step.steps && step.steps.length > 0) {
                                step.steps.forEach((ns) => {
                                    ns.status = getStep(resp.data.success.stageDetilasList, ns.stageCode)
                                    if (resp.data.success.isMF && (ns.stageCode == "PAY" || ns.stageCode == "BROK")) {
                                        ns.status = 1
                                    } else if (ns.stageCode == "PAY" && ns.status == 1) {

                                    }
                                })
                            }
                        })

                        for (let i = 0; i < Steps.length; i++) {
                            let arr = ["/ThirdParty", "/Profile", "/BankDetails", "/PlanDetails", "/Upload", "/Review", "/Esign", "/Courier", "/Scrutiny", "/Objection"]
                            if (!Steps[i].steps && Steps[i].status === 0) {
                                if (resp.data.success.isMF && i > 2) {
                                    navigate(arr[i - 1]);
                                    return
                                }
                                navigate(arr[i]);
                                return
                            }
                            if (Steps[i].steps && Steps[i].steps.length > 0) {
                                for (let j = 0; j < Steps[i].steps.length; j++) {
                                    if (Steps[i].steps[j].status === 0) {
                                        let nestedStepNavs = {
                                            "PERSO": "/Profile",
                                            "ADD": "/AddressDetails",
                                            "BASIC": "/AddressDetails",
                                            "BROK": "/PlanDetails",
                                            "PAY": "/Payment"
                                        }
                                        if (resp.data.success.isMF && i > 2) {
                                            navigate(nestedStepNavs[Steps[i].steps[j].stageCode]);
                                            return
                                        }

                                        navigate(nestedStepNavs[Steps[i].steps[j].stageCode]);
                                        return
                                    }
                                }
                            }
                        }
                        }
                    }
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const getPANImage = (proofID) => {
        let payload = {
            id: proofID,
            productType: "diy"
        }
        axios.post(process.env.REACT_APP_API_URL + config.getDocument, payload)
            .then(resp => {
                if (resp.data.success) {
                    setUploadedPANImage(resp.data.success[0])
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch(error => {
                setResponseStatus({ "message": error.message, "type": "error" })
                setSnackBarOpen(true)
            })

    }

    const getPANDetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getPanDetails)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    let dobDateObj = new Date(Number(resp.data.success[0].dob));
                    formik.setFieldValue("panNumber", resp.data.success[0].panNo)
                    formik.setFieldValue("dateOfBirth", dobDateObj)
                    formik.setFieldValue("segments", resp.data.success[0].segment.split(",").map(seg => Number(seg)))
                    formik.setFieldValue("referralCode", resp.data.success[0].referralCode)
                    resp.data.success[0]?.kycFormProofUpload[0]?.kycstgProofId && getPANImage(resp.data.success[0].kycFormProofUpload[0].kycstgProofId)
                    setPanDetails(resp.data.success[0])
                    setDisableAllFields(true)
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }

    const getSegments = () => {
        axios.get(process.env.REACT_APP_API_URL + config.segments)
            .then(resp => {
                if (resp.data.success) {
                    setSegmentOptions(resp.data.success.segments)
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    const validationSchema = yup.object({
        panNumber: yup
            .string('PAN Number is required')
            .matches(/[A-Za-z]{3}[pP]{1}[A-Za-z]{1}\d{4}[A-Za-z]{1}/, localeText?.kycVerificationEnterValidPanNumber)
            .required(localeText?.kycVerificationPanRequired),
        firstName: yup
            .string('Fisrt Name is required')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.validFirstNameAsPerPan)
            .required(localeText?.firstNameAsperPanRequired),
        middleName: yup
            .string('Middle Name is required')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.validMiddleNameAsPerPan),
            // .required(localeText?.middleNameAsperPanRequired),
        lastName: yup
            .string('Last Name is required')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.validLastNameAsPerPan),
            // .required(localeText?.lastNameAsperPanRequired),
        dateOfBirth: yup
            .date('')
            .required(localeText?.kycVerificationDateOfBirthRequired)
            .nullable(),
        apCode: yup
            .string(''),
        // .required('AP Code is required'),
        isIndianResident: yup
            .boolean(''),
        segments: yup
            .array('')
            .required(localeText?.kycVerificationSegmentRequired),
    });

    const toggleKRAVerifiedPopup = () => {
        setOpenKRAVerifiedPopup(!openKRAVerifiedPopup)
    }

    const toggleAadhaarSeededPopup = () => {
        setOpenAadhaarSeededPopup(!openAadhaarSeededPopup)
    }

    const nextNavigation = () => {
        if (objectionState.isObjection) {
            objectionNavigation(navigate)
        }
        else {
                navigate("/Profile")
        }
    }

    const handleSubmit = (values) => {
        if ( checkSegments() && !uploadedDocuments.find(upload => upload.documentTypeCode) ) {
            setResponseStatus({ "message": "Document Upload Mandatory", "type": "error" })
            setSnackBarOpen(true)
            return
        }
        setLoading(true)
        let data = {}
        // data.referralCode = values.referralCode
        data.isResidentIndia = true
        data.isTradebullDeclare = true
        data.dob = String(new Date(values.dateOfBirth).getTime())
        data.panNo = values.panNumber?.toUpperCase()
        data.firstName=values?.firstName
        data.middleName=values?.middleName
        data.lastName=values?.lastName
        data.segment = values.segments.join(",")
        data.isObjection = false
        axios.post(process.env.REACT_APP_API_URL + config.panVerification, data)
            .then(resp => {
                setLoading(false)
                if (resp.data.error) {
                    if(isUploaded){
                        isUploadedSubmit=true
                    }
                    isErrorSubmit=true
                   
                    throw new Error(resp.data.error)
                } else {
                        if (resp.data.success.isKRAVerified) {
                            setAadhaarSeededMessage(resp.data.success.aadhaarSeededMessage || '')
                            localStorage.setItem("kra", true)
                            toggleKRAVerifiedPopup()
                        } 
                        else if (resp.data.success.aadhaarSeededMessage){
                            toggleAadhaarSeededPopup()
                            setAadhaarSeededMessage(resp.data.success.aadhaarSeededMessage || '')
                        }
                        else {
                            localStorage.setItem("kra", false)
                            nextNavigation()
                        }
                        let storeObj = { ...store }
                        if (store.logger && store.logger === "withDigiLocker") {
                            storeObj.digilockerData = { ...store.digilockerData || {}, pan: values.panNumber?.toUpperCase() || "", dateofBirth: String(new Date(values.dateOfBirth).getTime()) }
                        } else {
                            dispatch(updateStepper({ step: 1, nestedStep: 1 }));
                        }
                        dispatch(addStageData({...storeObj, isFreshUser:true}))
                    localStorage.setItem("personalDetails", JSON.stringify(resp.data.success))
                    // window.open(`${window.location.origin}${"/Profile"}`, "_self")
                }
            }).catch(err => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
                setOpenInfoPopup(true)
                setPanDetailsStatus(true)
            })
    }


    const formik = useFormik({
        initialValues: {
            panNumber: '',
            firstName:'',
            middleName:'',
            lastName:'',
            dateOfBirth: null,
            apCode: "",
            isIndianResident: true,
            referralCode: "",
            segments: [1, 2]
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleSubmit(values)
        },
    });

    function getMajorDate(years) {
        let date = new Date()
        date.setFullYear(date.getFullYear() - years)
        date.setDate(date.getDate() - 1)
        date = new Date(date.getTime())
        return date
    }

    const getEncodedPANData = (imageData) => {
        let payload = {
            "encodedData": imageData.base64Format,
            "type": "pan"
        }
        setLoading(true)
        axios.post(process.env.REACT_APP_API_URL + config.getPANEncodingData, payload)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    setUploadedPANImage(imageData)
                    formik.setFieldValue("panNumber", resp.data.success[0].pan)
                    formik.setFieldValue("dateOfBirth", resp.data.success[0].dob ? new Date(Number(resp.data.success[0].dob)) : null)
                    setDisableAllFields(false)
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const getUploadedImageData = (imageData) =>{
        let payload = {
            "pageNo": 1,
            "uploadId": "1",
            "docTypeCode": "POI",
            "docMId": "1",
            "type": "holder1",
            "objectionId": "",
            "base64Format": imageData?.base64Format,
            "fileType": imageData?.fileType,
            "product": "diy",
            "documentExpiryDate": "",
            "documentNumber": "",
            "isOcrRequired": imageData?.isOcrRequired ? true : process.env.REACT_APP_AINxt == "false" ? false : true
        }
        setLoading(true)
        axios.post(process.env.REACT_APP_API_URL + config.uploadDocument, payload)
            .then(resp => {
                if (resp.data.success) {
                    if(resp.data.success[0]?.ocrDetails?.pan_no && resp.data.success[0]?.ocrDetails?.firstName && resp?.data?.success[0]?.ocrDetails?.date_of_birth){
                        if(process.env.REACT_APP_AINxt){
                            var dateParts = resp?.data?.success[0]?.ocrDetails?.date_of_birth?.split("/")
                            formik.setFieldValue("firstName", resp?.data?.success[0]?.ocrDetails?.firstName)
                            formik.setFieldValue("middleName", resp?.data?.success[0]?.ocrDetails?.middleName)
                            formik.setFieldValue("lastName", resp?.data?.success[0]?.ocrDetails?.lastName)
                            formik.setFieldValue("panNumber", resp.data.success[0]?.ocrDetails?.pan_no)
                            formik.setFieldValue("dateOfBirth", (new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]) || ""))
                        }
                        setIsUploaded("success")
                        setLoading(false)
                        setIsStatus("success")
                        setSnackBarOpen(true)
                    }else{
                        setLoading(false)
                        setIsUploaded("error")
                        // setResponseStatus({ "message": "error occurs", "type": "error" })
                        setIsStatus("error")
                        setSnackBarOpen(true)
                    }
                } else {
                    setIsUploaded("error")
                    setLoading(false)
                    setIsStatus("error")
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setIsUploaded("error")
                setLoading(false)
                setIsStatus("error")
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
            
    }

    const handleUploadPanImage = (imageData) => {

        let payload = {
            "pageNo": 1,
            "uploadId": "1",
            "docTypeCode": "POI",
            "docMId": "1",
            "type": "holder1",
            "objectionId": "",
            "base64Format": imageData.base64Format,
            "fileType": imageData.fileType,
            "product": "diy",
            "documentExpiryDate": "",
            "documentNumber": "",
            "isOcrRequired": process.env.REACT_APP_AINxt == "false" ? false : true
        }
        setLoading(true)
        axios.post(process.env.REACT_APP_API_URL + config.uploadDocument, payload)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    setUploadedPANProofID(resp.data.success[0].id)
                    getEncodedPANData(imageData)
                    setResponseStatus({ "message": localeText?.kycUploadedSucc, "type": "success" })
                    setSnackBarOpen(true)
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const handleDeletePANImage = () => {
        let payload = {
            "id": uploadedPANProofID || panDetails?.kycFormProofUpload[0]?.kycstgProofId,
            "productType": "diy"
        }
        setLoading(true)
        axios.post(process.env.REACT_APP_API_URL + config.deleteDocument, payload)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    setUploadedPANImage()
                    setResponseStatus({ "message": resp.data.success, "type": "success" })
                    setSnackBarOpen(true)
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const handleShowUploadPAN = () => {
        setShowUploadPAN(true)
    }
    const toggleWithPdfViewPopup = () => {
        setShowPdfPopup(!showPdfPopup)
    }
		const togglePanFailPopup = () => {
        setShowFailPopup({...showFailPopup,showPopup:!showFailPopup.showPopup})
		}    

		const handleKycReload = () =>{
			togglePanFailPopup()
			window.location.reload();
		}
    const handleToggleInfoPopup = () =>{
        setOpenInfoPopup(!openInfoPopup)
    }

    const displayData = (index) => {
        value=formik?.values?.segments
        if (index == 2 ) {
            setIndexValue(2)
        } else {
            setIndexValue(index)
        }
    }

    useEffect(() => {
        displayData()
    }, [value])

    const content = () => {
        return (
            <Grid container>
                <Grid item xs={10} md={12} css={{ height: "100vh" }}>
                    <PDFViewer pdfFile={"data:application/pdf;base64," + uploadedPANImage?.base64Format} />
                </Grid>
            </Grid>
        )
    }
 
    const handleImageUpload = async(event) => {
			const source = axios.CancelToken.source();
        let docName = event.currentTarget.files[0].name
        if(!(docName.match(/\.(jpg|jpeg|png|pdf)$/i))){
            setResponseStatus({ "message": localeText?.kycVerificationInvalidFormat, "type": "error" })
            setSnackBarOpen(true)
            return;
        }
        setOcrUploadLoading(true)
        if(event.currentTarget.files[0]){
            let response = await onFileSelection(event.currentTarget.files[0])
            if (response.data) {
                setImageData(response)
								const payload = {
									"file": response?.data?.split(',')[1],
									"mimeType":docName.match(/\.(pdf)$/i) ? "application/pdf":"image/jpeg",
									"isOCR":true
								}
								axios.post(process.env.REACT_APP_AARAMBHAH_URL + config.verifyPAN, payload,
									{
										cancelToken: source.token,
										timeout: 60000, // time in ms
									}
								).then(resp => {
											if(resp?.OCR?.isForceProceed || resp?.OCR.status === true){
												if(resp?.OCR?.isForceProceed != true || (resp?.OCR.status === true )){
													var dateData = resp?.OCR?.dateOfBirth.split('/')
													formik.setFieldValue("panNumber", (resp?.OCR?.PANNumber || ""))
													formik.setFieldValue("firstName", (resp?.OCR?.firstName || ""))
													formik.setFieldValue("middleName",(resp?.OCR?.middleName || resp?.OCR?.fatherName || ""))
													formik.setFieldValue("lastName", (resp?.OCR?.lastName || ""))
													formik.setFieldValue("dateOfBirth", (dateData?.length > 0 ? new Date(+dateData[2], dateData[1] - 1, +dateData[0]) : null))
												}else{
													formik.setFieldValue("panNumber", "")
													formik.setFieldValue("firstName", "")
													formik.setFieldValue("middleName","")
													formik.setFieldValue("lastName", "")
													formik.setFieldValue("dateOfBirth", null)
												}
													getUploadedImageData({"fileType": response?.type?.split('/')[1], "base64Format": response?.data?.split(",")[1]})
													setIsStatus("success")
													setIsUploaded("success")
													setOcrUploadLoading(false)
											}else{
													setSnackBarOpen(false)
													// setResponseStatus({"message":resp?.OCR?.message, "type":"error"})
													setOcrUploadLoading(false)
													setShowFailPopup({showPopup:true,showPopupMessage:resp?.OCR?.message || localeText.panStatusFailMessage1})
													// throw resp?.OCR?.message
												}
										}).catch(error=>{
													if(error.message){
														getUploadedImageData({"fileType": response?.type?.split('/')[1], "base64Format": response?.data?.split(",")[1], "isOcrRequired": true})
														setOcrUploadLoading(false)
													}
													setIsStatus("error")
													setIsUploaded("error")
													if (axios.isCancel(error)) {
														console.log('Request canceled:', error.message);
													} else if (error.code === 'ECONNABORTED') {  // timeout handling
														console.log('Request timed out');
													} else {
														console.log('Request Error:', error.message);
													}
										})
						} else {
							setResponseStatus({ "message": response, "type": "error" })
							setSnackBarOpen(true)
							setImageData({})
						}
        }
    };


    const fetchPanRelatedData = (panNum) => {
        if(panNum == "" || Boolean(formik.errors.panNumber)){
           setSnackBarOpen(true)
           setResponseStatus({ "message": formik.errors.panNumber || "PAN is required", "type": "error" })
        }else{
            setLoading(true)
            if (panNum) {
                let payload = {
                    "pan": panNum
                }
                axios.post(process.env.REACT_APP_AARAMBHAH_URL + config.getPanRelateData, payload)
                    .then(resp => {
                        if (resp.status || resp.isForceProceed) {
                            formik.setFieldValue("firstName", (resp?.firstname || ""))
                            formik.setFieldValue("middleName",(resp?.middlename || ""))
                            formik.setFieldValue("lastName", (resp?.lastname || ""))
                            if(resp.status){
                                var dateParts = resp?.dob?.split("-")
                                formik.setFieldValue("dateOfBirth", (new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]) || ""))
                            }
                            else{
                                setResponseStatus({ "message": resp.message, "type": "error" })
                                setSnackBarOpen(true)
                            }
                            setIsStatus("success")
                            setLoading(false)
                        }
                        else {
                            setLoading(false)
                            setIsStatus("error")
                            setResponseStatus({ "message": resp.message, "type": "error" })
                            setSnackBarOpen(true)
                            // throw new Error(resp.data.error)
                        }
                    })
                    .catch(error => {
                        setResponseStatus({ "message": error.message, "type": "error" })
                        setSnackBarOpen(true)
                        setIsStatus("error")
                        setLoading(true)
                    })
            }
        }
    }
    const getFilteredDocs = (id, documentData) =>{
        let filteredUploadedDocs = uploadedDocuments?.filter(item =>item.documentTypeCode !== id)
        setUploadedDocuments(filteredUploadedDocs)
    }
    console.log("Formik Values", formik?.values);
    console.log("Formik Errors", formik?.errors);
  
    return (
        <>
            <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
                <PageLayout css={{ overflowY: "scroll" }} showSidebar calculateHeight={isSmallScreen ? true : false}
                    breadcrumb={{ show: true, steps: steps[0].nestedSteps, step: 1, nestedStep: 1 }}
                    isObjectionScreen={objectionState.isObjection}
                >
                    <ElevatedGrid >
                        <Grid container item alignItems={"start"} >
                            <Grid container item alignItems={"center"}>
                                {objectionState.isObjection && <Grid item xs={12} css={{ padding: "10px", color: "white", backgroundColor: "lightcoral", borderRadius: "10px", margin: "10px 0px" }}>
                                    {objectionState.objections.map((objection, i) =>
                                        <>
                                            <Typography align="center" display="inline" variant="body2" fontWeight={"bold"}>
                                                {localeText?.profileObjection} {objection.objectionDescription || "--"} {localeText?.profileObjectionRemark} {objection.remark || "--"} <br />
                                            </Typography>
                                            {i > 0 && <Divider />}
                                        </>
                                    )}
                                </Grid>}
                                <Grid item>
                                    <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                        {localeText?.kycVerificationPan}
                                    </Typography>
                                </Grid>
                                {/* Below code has been disabled due to legacy issue in OCR. */}
                                {/* {!uploadedPANImage && !showUploadPAN && <Grid item>
                                    <Button color="secondary" variant="outlined" css={{ textTransform: "none", marginLeft: "40px" }} onClick={handleShowUploadPAN}>
                                        {localeText?.kycVerificationUpload}
                                    </Button>
                                </Grid>} */}
                                {disableAllFields && <Grid item css={{ marginLeft: "auto" }}>
                                    <img src="images/icon_complete-tick.svg" alt="icon_complete-tick" />
                                </Grid>}
                            </Grid>
                             {uploadedPANImage ?
                                <Grid container item xs={12} justifyContent={"center"} alignItems={"center"} spacing={1} css={{ padding: "10px" }}>
                                    <Grid item xs={12}>
                                        <Typography variant="body1" fontWeight={"bold"}>
                                            {localeText?.kycVerificationPanCard}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div css={{ position: "relative", width: "fit-content" }}>

                                            {uploadedPANImage.fileType == 'pdf' ?
                                                <div css={{ textAlign: "center", padding: "20px" }}>
                                                    <PictureAsPdfIcon css={{ height: "50px", width: "100%", cursor: "pointer", color: "#24B7CC" }} data={`data:image/${uploadedPANImage.fileType};base64,${uploadedPANImage.base64Format}`}
                                                        onClick={toggleWithPdfViewPopup} />
                                                    <span css={{ fontSize: "12px" }}>{uploadedPANImage.documentTypeCode}</span>
                                                </div> :
                                                <>
                                                    <div css={{ position: "absolute", right: "12px", top: "12px", cursor: "pointer", height: "30px", width: "30px", borderRadius: "50%", backgroundColor: "black", opacity: "0.75" }} onClick={handleDeletePANImage}>
                                                        <img src="images/delete_icon.svg" css={{ marginLeft: "8px", marginTop: "5px" }} alt="delete" />
                                                    </div>
                                                    <img css={{ height: "300px", width: "100%" }} src={`data:image/${uploadedPANImage.fileType};base64,${uploadedPANImage.base64Format}`} alt="uploadedImage" />
                                                </>
                                            }

                                        </div>
                                    </Grid>
                                </Grid>
                                :
                                showUploadPAN && <UploadPAN
                                    setUploadedPANImage={setUploadedPANImage}
                                    setShowUploadPAN={setShowUploadPAN}
                                    handleUploadPanImage={handleUploadPanImage}
                                    setResponseStatus={setResponseStatus}
                                    setSnackBarOpen={setSnackBarOpen}
                                />
                            }
                            <Grid container item>
                                <Grid item xs={12} css={{ marginTop: "5px" }}>
                                    <Grid container item xs={12} spacing="12" sx={{alignItems:'center'}}>
                                        <Grid item lg={isStatus == "" ? 2.5 : 4} md={6} xs={12} sx={{paddingTop:'0px'}}>
                                            <StyledTextField id="panNumber" name="panNumber" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                value={formik.values.panNumber?.toUpperCase()}
                                                error={formik.touched.panNumber && Boolean(formik.errors.panNumber)}
                                                helperText={formik.touched.panNumber && formik.errors.panNumber}
                                                inputProps={{ maxLength: 10 }} fullWidth
                                                label={localeText?.kycVerificationNumber} variant="outlined"
                                                onChange={(e) => formik.setFieldValue('panNumber', e.target.value?.toUpperCase())}
                                                // disabled={disableAllFields}
                                                disabled={((disableAllFields || isStatus != "") && isUploaded !='error' && !isUploadedSubmit) }
                                            />
                                        </Grid>
                                        { (isStatus == "") && 
                                            <Grid item lg={1.5} md={6} xs={12} sx={{display:'flex', flexDirection:'row', justifyContent:isMidScreen ? 'start':'center', alignItems:'start'}}>
                                            <Button disabled={isStatus != ""} variant='contained' color="primary" css={{ marginTop: "10px", width:'auto' }} onClick={()=>fetchPanRelatedData(formik.values.panNumber)}>
                                                Get PAN Details
                                            </Button>
                                            </Grid>
                                        }
                                        { isStatus == "" &&
                                            <>
                                                <Grid item lg={3} md={6} xs={12} >
                                                    <Grid sx={{ display: 'flex', flexDirection: 'row', justifyContent: isSmallScreen ? 'start' : 'center', alignItems: 'center' }}>
                                                        <Typography variant='h3' sx={{ fontWeight: 'bold' }}>OR</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item lg={4} md={6} xs={12}  sx={{padding:'inherit', alignItems:'center' }}>
                                                    <Grid sx={{ display: 'flex', flexDirection: 'row', justifyContent: isSmallScreen ? 'start' : 'center', alignItems: 'center' }}>
                                                        <Grid
                                                            style={{
                                                                border: '2px dashed #24b7cc',
                                                                borderRadius: '10px',
                                                                padding: '10px',
                                                                textAlign: 'center',
                                                                cursor: 'pointer',
                                                                width: '300px',
                                                                // margin: '20px auto'
                                                            }}>
                                                                    <input type="file" accept="image/*" disabled={Object.keys(imageData).length > 0} onChange={handleImageUpload} multiple style={{ display: 'none' }} id="fileInput" />
                                                                    <label htmlFor="fileInput" style={{ display: 'block' }}>
                                                                        <Grid sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', padding: '0px 25px', cursor:'pointer' }}>
                                                                            <CloudUploadIcon sx={{ color: '#24b7cc', fontSize: '50px' }} />
                                                                            <Typography variant='h6' sx={{ fontWeight: 'bold' }}>{localeText?.uploadPanText}</Typography>
                                                                        </Grid>
                                                                    </label>
                                                            <Grid alignItems={"center"} justifyContent={"flex-end"} container spacing={2} css={{ padding: "10px" }}></Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }
                                        <Grid item lg={4} md={6} xs={12} display={(isStatus) ? "block" : "none"}>
                                            <StyledTextField id="firstName" name="firstName" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                value={formik.values.firstName}
                                                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                                helperText={formik.touched.firstName && formik.errors.firstName}
                                                inputProps={{ maxLength: 100 }} fullWidth
                                                label={localeText?.kycFirstNameAsPerPan} variant="outlined"
                                                // onChange={formik.handleChange}
                                                onChange={(e)=>{
                                                    formik.handleChange(e)
                                                    formik.setFieldValue('firstName', e.currentTarget.value)}}
                                            />
                                        </Grid>
                                        <Grid item lg={4} md={6} xs={12} display={(isStatus) ? "block" : "none"}>
                                            <StyledTextField id="middleName" name="middleName" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                // required
                                                value={formik.values.middleName}
                                                error={formik.touched.middleName && Boolean(formik.errors.middleName)}
                                                helperText={formik.touched.middleName && formik.errors.middleName}
                                                inputProps={{ maxLength: 100 }} fullWidth
                                                label={localeText?.kycMiddleNameAsPerPan} variant="outlined"
                                                // onChange={formik.handleChange}
                                                onChange={(e)=>{
                                                    formik.handleChange(e)
                                                    formik.setFieldValue('middleName', e.currentTarget.value)}}
                                            />
                                        </Grid>
                                        <Grid item lg={4} md={6} xs={12} display={(isStatus) ? "block" : "none"}>
                                            <StyledTextField id="lastName" name="lastName" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                // required
                                                value={formik.values.lastName}
                                                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                                helperText={formik.touched.lastName && formik.errors.lastName}
                                                inputProps={{ maxLength: 100 }} fullWidth
                                                label={localeText?.kycLastNameAsPerPan} variant="outlined"
                                                // onChange={formik.handleChange}
                                                onChange={(e)=>{
                                                    formik.handleChange(e)
                                                    formik.setFieldValue('lastName', e.currentTarget.value)}}
                                            />
                                        </Grid>
                                        <Grid item xl={8} lg={8} md={8} xs={12} display={(isStatus) ? "block" : "none"}>
                                        <Button variant='contained' color="primary" css={{ marginTop: "10px" }} onClick={handleToggleInfoPopup}>
                                            <InfoOutlinedIcon fontSize='medium'/>
                                        </Button>
                                        </Grid>
                                        <Grid item xl={4} lg={4} md={6} xs={12} display={(isStatus) ? "block" : "none"}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker css={{ width: "100%", marginTop: "10px" }}
                                                    inputFormat="DD/MM/YYYY"
                                                    id="dateOfBirth" name="dateOfBirth"
                                                    value={formik.values.dateOfBirth}
                                                    maxDate={getMajorDate(18)}
                                                    label={localeText?.kycVerificationDate}
                                                    onChange={e => {
                                                        formik.setFieldValue("dateOfBirth", (e && e.$d && e?.$d !== 'Invalid Date') ? e.$d : "")
                                                    }}
                                                    renderInput={(params) => <StyledTextField
                                                        fullWidth
                                                        required
                                                        error={formik.touched.dateOfBirth && Boolean(formik.errors.dateOfBirth)}
                                                        helperText={formik.touched.dateOfBirth && formik.errors.dateOfBirth}
                                                        {...params}
                                                    />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xl={4} lg={4} md={6} xs={12} display={(isStatus) ? "block" : "none"}>
                                            <StyledTextField id="apCode" name="apCode" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                disabled
                                                value={formik.values.apCode}
                                                error={formik.touched.apCode && Boolean(formik.errors.apCode)}
                                                helperText={formik.touched.apCode && formik.errors.apCode}
                                                inputProps={{ maxLength: 10 }} fullWidth
                                                label={localeText?.kycVerificationCode} variant="outlined"
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                        <Grid item lg={4} md={6} xs={12} display={(isStatus) ? "block" : "none"}>
                                            <FormGroup css={{ border: "1px solid #D0D0D0", marginTop: "9px", borderRadius: "3px" }} key={formik.values.isIndianResident}>
                                                <FormControlLabel control={<Checkbox css={{ marginLeft: "20px", padding: "7px" }} name="isIndianResident" id="isIndianResident" checked={formik.values.isIndianResident} onChange={e => formik.setFieldValue("isIndianResident", e.currentTarget.checked)} />}
                                                    label={localeText?.kycVerificationResident}
                                                />
                                            </FormGroup>
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid item xs={12} css={{ marginTop: "20px" }}>
                                    <Typography display={"inline"} variant='body2' css={{ fontWeight: "bold" }}>
                                        {localeText?.kycVerificationDisclaimer}
                                    </Typography>
                                    <Typography display={"inline"} variant='body2'>
                                        {localeText?.kycVerificationAgency}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} css={{ marginTop: "20px" }}>
                                    <Typography display={"inline"} variant='body2' css={{ fontWeight: "bold" }}>
                                        {localeText?.kycVerificationNote}
                                    </Typography>
                                    <div style={{display:'flex',flexDirection:'column'}}>
                                    <Typography display={"inline"} variant='body2'>
                                        1.{localeText?.kycVerificationNoteMsg}
                                    </Typography>
                                    <Typography display={"inline"} variant='body2'>
                                        2. <span style={{color:"red"}}>{localeText?.kycVerificationNoteMsg2}</span>
                                    </Typography>
                                    </div>
                                </Grid>

                                <Grid item xs={12} css={{ marginTop: "20px" }}>
                                    <Divider />
                                </Grid>

                                <Grid container item xs={12} spacing={2} css={{ marginTop: "5px" }} display={(isStatus) ? "block" : "none"}>
                                    <Grid item xs={12} css={{ fontWeight: "bold" }}>
                                        {localeText?.kycVerificationSegment}
                                    </Grid>
                                    <Grid item xs={12} css={{ textTransform: "none", textAlign: isSmallScreen ? "center" : "none" }}>
                                        <FormControl error={formik.touched.segments && Boolean(formik.errors.segments)} >
                                            <ToggleButtonGroup
                                                orientation={isSmallScreen ? "vertical" : "horizontal"}
                                                value={formik.values.segments}
                                                id="segments"
                                                disabled={disableAllFields}
                                                name="segments"
                                                onChange={(e, value) => {
                                                    if (value && value.includes(1) && value.includes(2)) {
                                                        formik.setFieldValue("segments", value)
                                                    }
                                                }}
                                                color="primary"
                                            >
                                                {segmentOptions.sort((a, b) => a.id - b.id).map((segment, index) =>
                                                    <ToggleButton value={segment.id} onClick={() => displayData(index)}>
                                                        {segment.segmentDescription}
                                                    </ToggleButton>
                                                )}
                                            </ToggleButtonGroup>
                                            <FormHelperText>{formik.touched.segments && formik.errors.segments}</FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    {indexValue !== 2 && !(value).includes(3) ?
                                               <Grid item xs={12}>
                                               <Typography display={"inline"} variant='body2' css={{ fontWeight: "bold" }}>
                                                    {localeText?.kycVerificationNote}
                                                </Typography>
                                                <Typography display={"inline"} variant='body2'>
                                                    {<i>{localeText?.kycVerificationNoteText}</i>}
                                                </Typography>
                                        </Grid>
                                    :
                                        <Grid item xs={12}>
                                            <Typography display={"inline"} variant='body2' css={{ fontWeight: "bold" }}>
                                                {localeText?.kycVerificationNote}
                                            </Typography>
                                            <Typography display={"inline"} variant='body2'>
                                                {<i>{localeText?.kycVerificationNoteText}</i>}
                                            </Typography>
                                            <Typography  marginTop="10px" variant='body2' color="primary" css={{ fontWeight: "bolder"}}>
                                                {localeText?.fnoDetailHeader}
                                            </Typography>
                                            <Typography display={"inline"} variant='body2'>
                                                    <li>{localeText?.fnoDetailPoint1}</li>
                                                    <li>{localeText?.fnoDetailPoint2}</li>
                                                    <li>{localeText?.fnoDetailPoint3}</li>
                                                    <li>{localeText?.fnoDetailPoint4}</li>
                                            </Typography>
                                            <Typography variant='body2' color="primary">
                                            <a href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html" target="_blank" style={{color:"#24b7cc" , marginLeft:"20px"}}>Tap To Know More </a>
                                            </Typography>
                                        </Grid> 
                                    }
                                    <Grid item xs={12}>
                                        {
                                            checkSegments() && documentData &&
                                            <Upload
                                                masterId={documentData?.find(document => document?.documentTypeCode == "InPr")?.id}
                                                title={localeText?.UploadIncome}
                                                documentOptionData={{ id: "InPr", type: "holder1", code: "InPr", screen: "kyc" }}
                                                setUploadedDocuments={(data) => setUploadedDocuments([...uploadedDocuments, ...data])}
                                                uploadedDocuments={uploadedDocuments.filter(doc => doc.documentTypeCode == 'InPr')}
                                                
                                                documentData={documentData}
                                                setDocumentData={setDocumentData}
                                                getFilteredDocs={getFilteredDocs}

                                                isRequired={true}
                                            />
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </ElevatedGrid>
                    {!isSmallScreen && <Grid item css={{ marginTop: "40px" }}>
                        <Button disabled={!formik.values.isIndianResident || isStatus == "" } type="submit" variant='contained' color="primary" css={{ marginRight: "20px" }}>
                            {localeText?.kycVerificationDetails}
                        </Button>
                        <Button disabled={!panDetailsStatus} variant='contained' color="primary" onClick={()=>window.location.reload()}>
                            {localeText?.kycVerificationCancel}
                        </Button>
                    </Grid>}
                </PageLayout>

                {isSmallScreen && <Grid item css={{ display:'flex',flexDirection:'column', position: "fixed", bottom: 0, textAlign: "center", padding: "15px", width: "100%", boxShadow: "0px -15px 30px #00000029", backgroundColor: "#FFFFFF", zIndex: 1 }}>
                    <Button disabled={!formik.values.isIndianResident || isStatus == ""} type="submit" variant='contained' color="primary" css={{ marginBottom: "20px" }}>
                        {localeText?.kycVerificationDetails}
                    </Button>
                    <Button disabled={!panDetailsStatus} variant='contained' color="primary" onClick={()=>window.location.reload()}>
                        {localeText?.kycVerificationCancel}
                    </Button>
                </Grid>}
            </form>

            <Popup
                open={showPdfPopup}
                maxWidth={"sm"}
                fullScreen
            >
                <PopupTitle onClose={toggleWithPdfViewPopup} />
                <DialogContent css={{ textAlign: "center", margin: "0px 30px", height: "100vh" }}>

                    {content()}

                </DialogContent>
            </Popup>	

            {showFailPopup.showPopup && <Dialog
                open={showFailPopup.showPopup}
								maxWidth={"md"}
            >
                {/* <DialogTitle onClose={togglePanFailPopup} /> */}
								<DialogTitle dontShowCloseIcon>
									<Grid container direction={"column"} alignItems={"center"} justifyContent="center">
										<Grid item>
											<Typography variant="h6" css={{ fontWeight: "bold", textAlign: "center" }}>{localeText?.panStatusFailMessage}</Typography>
										</Grid>
									</Grid>
								</DialogTitle>
                <DialogContent dividers css={{ textAlign: "center", margin: "0px 30px", }}>
									<Grid container direction={"column"} alignItems={"center"} justifyContent="center">
										<Grid item>
											<Typography variant="h6">{showFailPopup.showPopupMessage}</Typography>
										</Grid>
									</Grid>
									<Grid item display={"flex"} justifyContent={"flex-end"}>
											<Button variant="contained" color="primary" css={{ textTransform: "none", marginTop: "50px" }} onClick={handleKycReload}>
												{localeText?.panStatusFailBtn}
											</Button>
										</Grid>
								</DialogContent>
            </Dialog>}

            {loading && <FullScreenLoader message={true}/>}
            {ocrUploadLoading && <FullScreenLoader message={true} countDownTimer={true} secondsToLoad={1.7}/>}
            <Popup
                open={openKRAVerifiedPopup}
                maxWidth={"sm"}
            >
                <PopupTitle dontShowCloseIcon />
                <DialogContent css={{ textAlign: "center", margin: "0px 60px" }}>
                    <Grid container direction={"column"} alignItems={"center"} justifyContent="center">
                        <Grid item>
                            <img src="images/icon_Bank-IMPS-Successful.svg" alt="success" />
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" css={{ fontWeight: "bold" }}>
                                {localeText?.kycYourKra}
                            </Typography>
                            {aadhaarSeededMessage &&
                                <Typography variant="h6" css={{ fontWeight: "bold" }}>
                                    {`Aadhaar Message: ${aadhaarSeededMessage}`}
                                </Typography>
                            }
                        </Grid>
                        <Grid item xs={12} css={{ padding: "20px 0" }}>
                            <Button variant="contained" color="secondary" css={{ textTransform: "none" }} onClick={() => {
                                toggleKRAVerifiedPopup();
                                nextNavigation()
                            }}>
                                {localeText?.bankDetailsNextBtn}
                            </Button>

                        </Grid>
                    </Grid>
                </DialogContent>
            </Popup>

            <Popup
                open={openAadhaarSeededPopup}
                maxWidth={"sm"}
            >
                <PopupTitle dontShowCloseIcon />
                <DialogContent css={{ textAlign: "center", margin: "0px 60px" }}>
                    <Grid container direction={"column"} alignItems={"center"} justifyContent="center">
                        <Grid item>
                            <Typography variant="h6">
                            {`Aadhaar Message: ${aadhaarSeededMessage}`}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} css={{ padding: "20px 0" }}>
                            <Button variant="contained" color="secondary" css={{ textTransform: "none" }}
                                onClick={() => { toggleAadhaarSeededPopup(); nextNavigation() }}>
                                {localeText?.bankDetailsNextBtn}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Popup>

            <Popup
            open={openInfoPopup}
            maxWidth={isSmallScreen ? 'xs' :'md'}
            margin='0px !important'
            width='100% !important'
            fullWidth  
            sx={{
              "& .MuiDialog-paper": {
                  margin:'0px !important',
                  width: 'calc(100% - 10px)'
              }
          }}          
        >
            <PopupTitle onClose={()=>handleToggleInfoPopup()}/>
            <DialogContent css={{ textAlign: "center", padding:isSmallScreen ? "20px 0px" : "20px", width:'100%'}}>
                <Grid container direction={"column"} alignItems={"center"} justifyContent="center"  >
                    <Grid item sx={{width:'100%'}}>
                <div className="pan-guide-wrap" /* style={{minWidth:!isSmallScreen && "880px"}} */ >
                  <h2 className="info">PAN Information filling guide</h2>
                  <div className="d-flex">
                    <div className="col">
                      <h3 className="txt-brown">Sample 1</h3>
                      <div className="pan-guide-animation">
                        <div className="pan-1">
                          <img src="images/pan-1.png" alt="Pancard" className="" width="360" height="215"/>
                            <div className="hover-box-1">
                              <span className="top"></span>
                              <span className="left"></span>
                              <span className="bottom"></span>
                              <span className="txt-box">AXXXKYA</span>
                              {/* <!-- <span className="hold-animation"></span> --> */}
                            </div>
                            <div className="hover-box-2">
                              <span className="right"></span>
                              <span className="top"></span>
                              <span className="left"></span>
                              <span className="bottom"></span>
                              <span className="txt-box">AVXXASH</span>
                              {/* <!-- <span className="hold-animation"></span> --> */}
                            </div>
                            <div className="hover-box-3">
                              <span className="right"></span>
                              <span className="top"></span>
                              <span className="left"></span>
                              <span className="bottom"></span>
                              <span className="txt-box">AXXR</span>
                              {/* <!-- <span className="hold-animation"></span> --> */}
                            </div>
                        </div>
                        <div className="input-wrap">
                          <img src="images/input-fields.svg" alt="Input Fields" className=""/>
                        </div>
                        <div className="txt-note">
                          <p><span className="txt-red">Note:</span> If your First row contains your First name, Middle & Last name, Then fill the Middle & Last name input of the form accordingly.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <h3 className="txt-brown">Sample 2</h3>
                      <div className="pan-guide-animation" >
                        <div className="pan-2">
                          <img src="images/pan-2.png" alt="Pancard" className="" width="360" height="215"/>
                            <div className="hover-box-1">
                              <span className="top"></span>
                              <span className="left"></span>
                              <span className="bottom"></span>
                              <span className="txt-box">PAXXAXX</span>
                              <span className="icon-incorrect">Not required</span>
                              <span className="icon-incorrect icon-2">Not required</span>
                            </div>
                        </div>
                        <div className="input-wrap">
                          <img src="images/input-fields.svg" alt="Input Fields" className=""/>
                        </div>
                        <div className="txt-note">
                          <p><span className="txt-red">Note:</span> If your first row contains only your first name then, Kindly leave the middle name and last name inputs of form blank.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                        {/* <img src={isSmallScreen ? "images/popupImg_mob.png" : "images/popupImg_web.png"} alt="error" style={{width:isSmallScreen ? '300px':'900px', height:isSmallScreen ? '300px' : '450px'}}/> */}
                    </Grid>
                    <Grid item xs={12} css={{ padding: "20px 0" }}>
                        <Button variant="contained" color="secondary" css={{ textTransform: "none"}} onClick={() => {
                            handleToggleInfoPopup();
                        }}>
                            {localeText?.popupImgCloseBtn}
                        </Button>

                    </Grid>
                </Grid>
            </DialogContent>
        </Popup>


            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default PANVerification;